var _style, _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRating = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1_copy",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n        .file1_st0{filter:url(#Adobe_OpacityMaskFilter);}\n        .file1_st1{fill:#FFFFFF;}\n        .file1_st2{mask:url(#SVGID_1_);}\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 42.7,
  y: 42.7,
  width: 426.6,
  height: 426.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
  colorInterpolationFilters: "sRGB",
  result: "source"
})))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 42.7,
  y: 42.7,
  width: 426.6,
  height: 426.6,
  id: "SVGID_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "file1_st0"
}, /*#__PURE__*/React.createElement("rect", {
  x: -23.6,
  y: -11.1,
  width: 554.2,
  height: 552.4
}), /*#__PURE__*/React.createElement("path", {
  className: "file1_st1",
  d: "M418.8,176.3c11.8,0,21.5,9.6,21.5,21v106.4c0,5.9-2.4,11.2-6.2,15.1L363.2,389l-11.4-11.1                 c-3-2.9-4.8-6.9-4.8-11.2l0.4-3.3l10-48.5h-67.9c-11.8,0-21.5-9.6-21.5-21.3v-21.3c0-2.8,0.6-5.4,1.6-7.8l32.5-75.1                 c3.2-7.7,10.9-13,19.9-13H418.8 M106.1,315.7c-11.8,0-21.4-9.6-21.3-21.2V188.5c0-5.9,2.4-11.1,6.2-14.9l70.7-70l11.4,11.1                 c2.9,2.9,4.7,6.9,4.7,11.2l-0.4,3.3l-10.2,48.5h67.7c11.8,0,21.5,9.4,21.5,21.2v21.2c0,2.8-0.6,5.4-1.6,7.8l-32.4,74.9                 c-3.2,7.7-10.9,12.9-19.7,12.9H106.1"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "file1_st2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256,42.7c117.8,0,213.3,95.5,213.3,213.3S373.8,469.3,256,469.3S42.7,373.8,42.7,256S138.2,42.7,256,42.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,426.7"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRating, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rating.4af84416.svg";
export { ForwardRef as ReactComponent };